<template>
  <v-card flat>
    <div style="height:80vh; overflow-y:auto;overflow-x:hidden">
      <v-toolbar class="mb-n6 mr-n4" flat>
        <v-spacer></v-spacer>
        <v-menu v-model="menuModel">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-1" icon small v-bind="attrs" v-on="on">
              <v-icon class="ma-2">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item>
              <v-btn text small v-if="!$root.isMobile" @click="savePref(true)"
                ><v-icon small class="ml-2">mdi-restore</v-icon>Restore Default
                Dashboard</v-btn
              >
            </v-list-item>
          </v-list>
          <v-menu v-model="menuShortcuts">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ma-1" text small v-bind="attrs" v-on="on">
                <v-icon small class="ma-2">mdi-playlist-remove</v-icon> Remove
                Shortcuts
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item v-for="(s, i) in shortcuts" :key="i">
                <v-row
                  style="text-align: left; white-space: nowrap; width: 100px"
                >
                  <!-- <v-col>
                  </v-col
                > -->
                  <v-col class="justify-left align-left">
                    <v-icon small class="mr-2">{{ s.icon }}</v-icon>
                    <v-span class="shortcut-text">{{ s.text }}</v-span>
                    <v-btn class="mt-n2 ml-1" icon @click="removeShortcut(i)"
                      ><v-icon color="error" small>mdi-close</v-icon></v-btn
                    >
                  </v-col></v-row
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-menu>
      </v-toolbar>
      <!-- <v-icon color="info" x-large>mdi-package-variant</v-icon> -->
      <div v-if="!dataReady">Loading dashboard...</div>
      <v-skeleton-loader
        v-if="!dataReady"
        class="mx-auto"
        :tile="true"
        max-width="90%"
        type="heading,table-tbody"
        loading-text="Loading Dashboard..."
      ></v-skeleton-loader>
      <v-card flat v-if="dataReady">
        <shortcuts :key="shorcutKey" :shortcuts="shortcuts"></shortcuts>

        <vuedraggable
          :key="dragKey"
          :disabled="mobileMode"
          :list="grid"
          class="grid ma-0"
        >
          <v-row
            v-for="(row, rowIndex) in filteredGrid"
            :key="rowIndex"
            class="grid-row"
          >
            <vuedraggable
              :disabled="mobileMode"
              :list="row"
              group="cells"
              class="grid-col"
            >
              <v-col v-for="(cell, colIndex) in row" :key="colIndex">
                <v-card
                  elevation="5"
                  color="#FAFAFA"
                  rounded
                  :itemId="cell._id"
                  :ref="'card' + rowIndex + '_' + colIndex"
                  class="pa-4 ma-2 gradient-background"
                  :style="
                    mobileMode
                      ? ''
                      : 'width:' + cell.width + ';height:' + cell.height
                  "
                >
                  <v-component
                    :is="cell.control_name"
                    v-bind="getProperties(cell.control_name)"
                  ></v-component>
                  <v-btn
                    v-if="!mobileMode"
                    small
                    icon
                    @mousedown.stop="startResizing(rowIndex, colIndex, $event)"
                    style="
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    cursor: nwse-resize;
                  "
                  >
                    <v-icon>mdi-resize-bottom-right</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </vuedraggable>
          </v-row>
        </vuedraggable>
      </v-card>
    </div>
    <!-- <AIChat assistantId="df04a6b83bd9d3fd3b574ad8"></AIChat> -->
  </v-card>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import * as fun from "../plugins/common";

import axios from "axios";
import vuedraggable from "vuedraggable";

export default {
  components: {
    // VDataCalendar: () => import("../components/DataCalendar.vue"),
    // DTable: () => import("../components/Table.vue"),
    vuedraggable,
    BookingTotal: () => import("../components/dashboard/Booking.vue"),
    SmsReceived: () => import("../components/dashboard/SMSReplies.vue"),
    Reminders: () => import("../components/dashboard/Reminders.vue"),
    BookingPerformanceGraph: () =>
      import("../components/dashboard/BookingPerformance.vue"),
    TodayJobs: () => import("../components/dashboard/TodayJobs.vue"),
    TodayLeads: () => import("../components/dashboard/TodayLeads.vue"),
    TodayBooked: () => import("../components/dashboard/TodayBooked.vue"),
    CustomerOrders: () => import("../components/dashboard/CustomerOrders.vue"),
    CustomerInventory: () =>
      import("../components/dashboard/CustomerInventory.vue"),
    SalesActivities: () =>
      import("../components/dashboard/SalesActivities.vue"),
    InternalChat: () => import("../components/dashboard/InternalChat.vue"),
    AIChat: () => import("../components/AIChat.vue"),
    BookedTotals: () => import("../components/dashboard/BookedTotals.vue"),
    Shortcuts: () => import("../components/dashboard/Shortcuts.vue")
  },
  data: () => ({
    dashboard: null,
    updateKey: 0,
    grid: [],
    updatedGrid: [],
    totals: null,
    rows: 0,
    cols: 0,
    numRows: 3,
    numCols: 4,
    dataReady: false,
    resizing: false,
    dragging: false,
    currentDraggedRow: null,
    currentDraggedCol: null,
    currentResizingIndex: null,
    startDate: null,
    endDate: null,
    serviceDate: null,
    imgPath: "user_images",
    defaultEventColor: "#137C15FF",
    firstInterval: "0",
    link: {
      field: "shipment_id",
      name: "shipment"
    },
    updatePref: false,
    darkMode: false,
    mobileMode: false,
    dashboardModified: false,
    menuModel: null,
    shortcuts: [],
    menuShortcuts: false,
    shorcutKey: 0,
    loading: true
  }),
  mounted() {
    // this.init();
    if (this.$root.store.portalData == "admin") {
      this.dataReady = true;
      return;
    }
    var data = {
      no_default: true,
      object_name: "shortcuts",
      all_records: true,
      qry: {
        user_id: this.$root.user_id
      }
    };

    axios
      .post(this.serverURL + "/get_data", data, {
        withCredentials: true
      })
      .then(response => {
        this.shortcuts = response.data.model;
        this.shorcutKey = !this.shorcutKey;
        this.loading = false;
      })
      .catch(r => {});
  },
  activated() {
    this.init();
    this.newLeadsTableKey = !this.newLeadsTableKey;
    this.calendarKey = !this.calendarKey;
  },
  methods: {
    removeShortcut(i) {
      var idToRemove = this.shortcuts[i]._id;
      this.shortcuts.splice(i, 1);

      // console.log(this.shortcuts);
      var data = {
        object_name: "shortcuts",
        ids: [idToRemove]
      };
      axios
        .post(this.serverURL + "/delete_records", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
        });
    },
    gridRepresentation() {
      const grid = Array.from({ length: this.numRows }).map(() =>
        Array(this.numCols).fill(null)
      );

      this.dashboard.forEach(item => {
        const rowIndex = parseInt(item.row, 10) - 1; // -1 because arrays are 0-indexed
        const colIndex = parseInt(item.col, 10) - 1;
        grid[rowIndex][colIndex] = item;
      });
      for (let i = 0; i < grid.length; i++) {
        grid[i] = grid[i].filter(cell => cell !== null);
        grid[i].sort((a, b) => parseInt(a.col, 10) - parseInt(b.col, 10));
        if (grid[i].length === 0) {
          grid.splice(i, 1);
          i--; // decrement counter because the array has shrunk
        }
      }
      return grid;
    },
    updateElement(el) {
      if (this.mobileMode) {
        return;
      }
      var curEl = this.updatedGrid.find(e => {
        return e._id == el._id;
      });
      if (!curEl) {
        curEl = {
          _id: el._id
        };
        this.updatedGrid.push(curEl);
      }
      Object.keys(el).forEach(k => {
        curEl[k] = el[k];
      });
      this.savePref();
    },

    startResizing(r, c, event) {
      if (this.mobileMode) {
        return;
      }
      var index = r + "_" + c;
      this.resizing = true;
      this.currentResizingIndex = index;
      document.addEventListener("mousemove", this.resize);
      document.addEventListener("mouseup", this.stopResizing);
      event.preventDefault();
    },
    resize(event) {
      if (this.mobileMode) {
        return;
      }
      if (this.resizing) {
        let item = "card" + this.currentResizingIndex;
        let cardElement = this.$refs[item][0].$el;
        var id = cardElement.attributes.itemid.nodeValue;
        cardElement.style.width =
          event.clientX - cardElement.getBoundingClientRect().left + "px";
        cardElement.style.height =
          event.clientY - cardElement.getBoundingClientRect().top + "px";

        this.updateElement({
          _id: id,
          width: cardElement.style.width,
          height: cardElement.style.height
        });
        this.updatePref = true;
      }
    },
    stopResizing() {
      if (this.mobileMode) {
        return;
      }
      this.resizing = false;
      document.removeEventListener("mousemove", this.resize);
      document.removeEventListener("mouseup", this.stopResizing);
    },

    getEventColor(event) {
      return event.color || this.defaultEventColor;
    },

    linkClick(item) {
      this.$root.addResentTab(item);
    },

    eventClick(e) {
      var item = {
        text:
          e.event.shipment_id +
          " " +
          e.event.first_name +
          " " +
          e.event.last_name,
        link: "/shipment/" + e.event.shipment_id,
        icon: "mdi-truck"
      };

      this.$root.addResentTab(item);
      this.$router.push({ path: item.link });
    },

    getDashboardComponent(controlName) {
      return (
        this.dashboard.filter(e => {
          return e.control_name == controlName;
        })[0] || {}
      );
    },

    getProperties(controlName) {
      var prop = {};
      try {
        prop = JSON.parse(
          this.getDashboardComponent(controlName).control_properties
        );
      } catch (error) {
        //
      }
      // if (prop) {
      //   prop = prop.value;
      // } else {
      //   prop = {};
      // }
      prop.link = this.link;
      prop.totals = this.totals;
      prop.linkClick = this.linkClick;
      prop.startDate = this.startDate;
      prop.endDate = this.endDate;
      prop.eventClick = this.eventClick;
      return prop;
    },
    init() {
      var that = this;
      if (this.$root.isMobile || this.$root.isTablet) {
        this.mobileMode = true;
      }
      this.$root.$on("themeChanged", r => {
        this.darkMode = this.$vuetify.theme.dark;
        this.savePref();
      });

      var start = fun.ignoreTimeZone(new Date());
      this.startDate = new Date(start.setDate(start.getDate()));
      var end = new Date();
      this.endDate = new Date(end.setDate(this.startDate.getDate() + 1));
      var roles = [];
      this.$root.roles.forEach(r => {
        if (!roles.includes(r)) {
          roles.push(r);
          roles.push(r.toLowerCase().replaceAll(" ", "_"));
        }
      });
      var data = {
        no_default: true,
        object_name: "dashboard_settings",
        all_records: true,
        qry: {
          roles: { $in: roles }
        },

        additional_data: [
          // {
          //   obj_name: "v_totals",
          //   all_records: true
          // },
          {
            obj_name: "user_preferences",
            qry: {
              user: this.$root.user_email
            },
            all_records: true
          }
        ]
      };

      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          try {
            response.data = JSON.parse(
              response.data.replace(/\bNaN\b/g, "null")
            );
          } catch (error) {
            //
          }

          this.dashboard = response.data.model;
          fun.sortObjects(this.dashboard, "row", true);
          this.numRows = this.dashboard[0].row;
          if (!this.dashboard || !this.dashboard.length) {
            this.dashboard = response.data.schema.default_values.filter(d => {
              return roles.some(role => d.roles.includes(role));
            });
          }
          var pref = response.data.additional_model.user_preferences[0];
          if (pref) {
            this.dashboardModified = pref.dashboard.length;
            if (
              pref &&
              pref.dashboard &&
              pref.dashboard.length &&
              !this.mobileMode
            ) {
              // that.dashboard = this.applyPref(pref.dashboard);
              that.dashboard = pref.dashboard;
            }
            this.$root.$emit("darkModeUpdated", pref.darkMode);
          }

          // console.log(that.dashboard);

          var addModel = response.data.additional_model;
          this.totals = addModel.v_totals;
          this.rows = fun.getMaxFieldValue(this.dashboard, "row");
          this.cols = fun.getMaxFieldValue(this.dashboard, "col");
          this.grid = this.gridRepresentation();
          this.dataReady = true;
        })
        .catch(r => {});
    },

    applyPref(prefDash) {
      // Convert prefDash into a map for O(1) access time by id
      const prefMap = prefDash.reduce((acc, item) => {
        acc[item._id] = item;
        return acc;
      }, {});

      console.log(prefMap);
      // Merge the arrays based on _id
      return this.dashboard.map(item => {
        if (prefMap[item._id]) {
          // If an item with the same _id exists in prefDash, merge the two items
          var m = {
            ...item, // spread all properties of the dashboard item
            ...prefMap[item._id] // spread properties of the matching prefDash item (this will overwrite properties of the dashboard item)
          };
          return m;
        }
        return item; // if no matching _id in prefDash, return the dashboard item unchanged
      });
    },
    savePref(reset) {
      var that = this;
      var data = {
        metadata: { object_name: "user_preferences" },
        model: {
          _id: this.$root.user_id,
          user: this.$root.user_email,
          dashboard: reset ? [] : this.updatedGrid,
          darkMode: reset ? false : this.darkMode
        }
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          // console.log(response.data);
          if (reset) {
            location.reload();
          }
        });
    }
  },
  watch: {
    filteredGrid() {
      if (this.mobileMode) {
        return;
      }
      this.filteredGrid.forEach((r, i) => {
        r.forEach((c, j) => {
          // console.log(c._id, c.control_name, i, j);
          this.updateElement({
            _id: c._id,
            control_name: c.control_name,
            row: i + 1,
            col: j + 1,
            width: c.width,
            height: c.height
          });
        });
      });
      this.savePref();
      // }
    }
  },
  computed: {
    filteredGrid() {
      var g = this.grid.filter(row => row.filter(cell => cell && cell._id));

      if (g.length == 1) {
        g = this.grid;
      }
      return g;
    }
  }
};
</script>
<style scoped>
.restore-button {
  /* position: absolute; */
  top: -40px;
  right: 0;
}
.grid {
  width: 100%;
}

.grid-row {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.theme--light.v-application ::-webkit-scrollbar {
  width: 13px;
}

.theme--light.v-application ::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.theme--light.v-application ::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
  border-radius: 7px;
}
.theme--dark div {
  background: black !important;
}
.theme--light.v-application ::-webkit-scrollbar-thumb:hover {
  background: black;
}

.theme--dark.v-application ::-webkit-scrollbar {
  width: 13px;
}

.theme--dark.v-application ::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.theme--dark.v-application ::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.theme--dark.v-application ::-webkit-scrollbar-thumb:hover {
  background: white;
}

.top-info {
  height: 150px;
  display: table;
  text-align: center;
  /* align-items: center;
  justify-content: center; */
  /* display: inline-block; */
}

.top-info-line {
  white-space: nowrap;
}
.grid-col {
  width: 100%;
}
@media only screen and (min-width: 600px) {
  .grid-col {
    display: flex;
  }
}
@media only screen and (max-width: 600px) {
  .grid-row {
    width: 100vw;
  }
  .grid {
    margin-left: -10px !important;
  }
}
</style>
